module.exports = __webpack_public_path__ + "img/P10-en.51e4b3ad.png";